import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["limitedList", "fullList", "showMoreButton"]

    static values = {
        showMoreText: String,
        showLessText: String
    }

    connect() {
        this.fullListTargets.forEach(element => {
            element.style.display = 'none'
        })

        console.log(this.showMoreTextValue)
    }

    toggleInvoices() {
        const isShowingLimited = this.fullListTargets[0].style.display === 'none'

        this.limitedListTargets.forEach(element => {
            element.style.display = isShowingLimited ? 'none' : ''
        })

        this.fullListTargets.forEach(element => {
            element.style.display = isShowingLimited ? '' : 'none'
        })

        this.showMoreButtonTarget.textContent = isShowingLimited
            ? this.showLessTextValue
            : this.showMoreTextValue
    }
}
